import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {EmptyLoadingStateHandler} from "../../../core/handlers/empty-loading-state-handler";
import {GameCenterContainerFetchHandler} from "./game-center-container.fetch-handler";
import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {GameCenterContainerMetadataFetchHandler} from "./game-center-container.metadata.fetch-handler";
import {BreadcrumbsClickHandler} from "../../../core/handlers/breadcrumbs-click.handler";

export class GameCenterContainerHandlers extends HandlerList {
  static injectables = [
    GameCenterContainerFetchHandler,
    GameCenterContainerMetadataFetchHandler,
    BreadcrumbsClickHandler,
    EntityClickEventHandler,
    EmptyLoadingStateHandler,
    PopulateDataHandler
  ];

  constructor(
    gameCenterContainerFetchHandler: GameCenterContainerFetchHandler,
    gameCenterContainerMetadataFetchHandler: GameCenterContainerMetadataFetchHandler,
    breadcrumbsClickHandler: BreadcrumbsClickHandler,
    entityClickEventHandler: EntityClickEventHandler,
    emptyStateHandler: EmptyLoadingStateHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      gameCenterContainerFetchHandler,
      gameCenterContainerMetadataFetchHandler,
      breadcrumbsClickHandler,
      entityClickEventHandler,
      emptyStateHandler,
      populateDataHandler,
    ].forEach(handler => this.add(handler));
  }
}